<template>
  <card shadow class="card-profile b-2" style="width: 100%; color: black;" no-body>
    <div class="px-4">
      <!-- Search Bar -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="display-3 mt-3">Каталогийн  жагсаалт</h1>
        <div class="d-flex align-items-center">
          <button class="btn btn-success" @click="CreateCatalog">Үүсгэх</button>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th>
              <button class="btn btn-link" @click="toggleSort">
                ID
                <i :class="sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
              </button>
            </th>
            <th>Зураг</th>
            <th>Холбоос</th>
            <th>Төлөв</th>
            <th class="text-right">Үйлдлүүд</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="info in filteredCatalogList" :key="info.id">
            <td>{{ info.id }}</td>

            <!-- ✅ Show Image -->
            <td style="width: 420px; display: block;">
              <img 
                v-if="info.image" 
                :src="info.image" 
                alt="Profile Image" 
                class="profile-image" 
                
              />
              <span v-else>-</span>
            </td>
            <td>
              <span :style="{
                        backgroundColor: info.active ? '#d1fae5' : '#e5e7eb',
                        color: info.active ? '#065f46' : '#4b5563',
                        padding: '4px 12px',
                        borderRadius: '9999px',
                        fontWeight: '500',
                        fontSize: '14px',
                        display: 'inline-block'
                      }"> {{ info.active ? "Харуулах" : "Харуулахгүй" }} </span>
            </td>
            <td>
              <a 
                v-if="info.link" 
                :href="info.link" 
                target="_blank" 
                class="link"
              >
                <span style="width: 100px; display: block;">{{ info.link }}</span>
              </a>
              <span v-else>-</span>
            </td>

            <!-- ✅ Action Buttons -->
            <td class="td-actions text-right">
              <button 
                type="button" 
                rel="tooltip" 
                class="btn btn-info btn-icon btn-sm" 
                @click="Edit(info)"
              >
                <i class="fa fa-pencil pt-1"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </card>
</template>

<script>
import axios from "axios";
import Modal from "@/components/Modal.vue";

export default {
  name: "catalog_list",
  data() {
    return {
      catalog_list: [],
      searchQuery: "",
      sortDirection: "asc"
    };
  },
  created() {
    this.fetchCatalogList();
  },
  components: {
    Modal,
  },
  computed: {
    filteredCatalogList() {
      let list = [...this.catalog_list];

      // ✅ Apply sorting
      list.sort((a, b) => {
        if (this.sortDirection === 'asc') {
          return a.id - b.id;
        } else {
          return b.id - a.id;
        }
      });

      return list;
    }
  },
  methods: {
    // ✅ Fetch catalog data
    fetchCatalogList() {
      axios
        .get("/catalog_list")
        .then((response) => {
          this.catalog_list = response.data;
        })
        .catch((error) => {
          console.error("Error fetching catalog list:", error);
        });
    },

    // ✅ Toggle sort direction
    toggleSort() {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    },

    // ✅ Edit record
    Edit(info) {
      console.log("Editing:", info);
      this.$router.push({ name: "catalog", params: { id: info.id } });
    },
    CreateCatalog() {
      this.$router.push({ name: "catalog", params: { id: 0 } });
    }
  }
};
</script>

<style scoped>
/* ✅ Style for the profile image */
.profile-image {
  width: 400px;
  height: 200px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #ccc;
}

/* ✅ Style for the link */
.link {
  color: #2d5a87;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

/* ✅ Sort Button */
.btn-link {
  text-decoration: none;
  color: inherit;
  padding: 0;
}

.btn-link:hover {
  text-decoration: none;
  color: inherit;
}

/* ✅ Style for the action buttons */
.btn-icon {
  padding: 6px 12px;
  border-radius: 4px;
  background-color: #2d5a87;
  color: white;
  transition: background-color 0.2s ease;
}

.btn-icon:hover {
  background-color: #1f4369;
}
</style>
